'use client';

import { createContext, useContext, type ReactNode } from 'react';

export type AttackPathCampaignHoverState = {
  campaignId: string | null;
  brightNodeIds: ReadonlySet<string> | null;
};

export const EMPTY_ATTACK_PATH_CAMPAIGN_HOVER: AttackPathCampaignHoverState = {
  campaignId: null,
  brightNodeIds: null,
};

const AttackPathCampaignHoverContext =
  createContext<AttackPathCampaignHoverState>(EMPTY_ATTACK_PATH_CAMPAIGN_HOVER);

export const AttackPathCampaignHoverProvider = ({
  value,
  children,
}: {
  value: AttackPathCampaignHoverState;
  children: ReactNode;
}) => (
  <AttackPathCampaignHoverContext.Provider value={value}>
    {children}
  </AttackPathCampaignHoverContext.Provider>
);

export const useAttackPathCampaignHover = (): AttackPathCampaignHoverState =>
  useContext(AttackPathCampaignHoverContext);
